/* eslint-disable */
/** auto generated list of available icons
regenerate with `npm run build:icons` */
module.exports = {
  "app": {
    "filename": "app.svg"
  },
  "arrow-down": {
    "filename": "arrow-down.svg"
  },
  "arrow-left": {
    "filename": "arrow-left.svg"
  },
  "arrow-right": {
    "filename": "arrow-right.svg"
  },
  "arrow-up": {
    "filename": "arrow-up.svg"
  },
  "bugtracker": {
    "filename": "bugtracker.svg"
  },
  "close": {
    "filename": "close.svg"
  },
  "color-app-white": {
    "filename": "color-app-white.svg"
  },
  "component": {
    "filename": "component.svg"
  },
  "config": {
    "filename": "config.svg"
  },
  "copylink": {
    "filename": "copylink.svg"
  },
  "deployed": {
    "filename": "deployed.svg"
  },
  "docs": {
    "filename": "docs.svg"
  },
  "failed": {
    "filename": "failed.svg"
  },
  "function": {
    "filename": "function.svg"
  },
  "github": {
    "filename": "github.svg"
  },
  "in-progress": {
    "filename": "in-progress.svg"
  },
  "info": {
    "filename": "info.svg"
  },
  "lightning": {
    "filename": "lightning.svg"
  },
  "lock": {
    "filename": "lock.svg"
  },
  "logo": {
    "filename": "logo.svg"
  },
  "menu": {
    "filename": "menu.svg"
  },
  "resource": {
    "filename": "resource.svg"
  },
  "search": {
    "filename": "search.svg"
  },
  "settings": {
    "filename": "settings.svg"
  },
  "subscription": {
    "filename": "subscription.svg"
  },
  "successful": {
    "filename": "successful.svg"
  },
  "undeployed": {
    "filename": "undeployed.svg"
  }
}


// WEBPACK FOOTER //
// ../src/icons/icon-list.js